(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mte-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dear-v-uro-faq')) {
    customElements.define('dear-v-uro-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.animations = new Map();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.querySelectorAll('.dv-uro-faq__question').forEach(question => {
          const panel = document.getElementById(question.getAttribute('aria-controls'));
          const open = question.getAttribute('aria-expanded') === 'true';
          panel.hidden = !open;
          panel.inert = !open;
          panel.setAttribute('aria-hidden', String(!open));
        });
        const options = { signal: this.controller.signal };
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('.dv-uro-faq__tab');
          if (tab && this.contains(tab)) {
            this.filter(tab.dataset.tabTarget);
            return;
          }
          const question = event.target.closest('.dv-uro-faq__question');
          if (question && this.contains(question)) {
            this.expand(question, question.getAttribute('aria-expanded') !== 'true');
            return;
          }
          const cta = event.target.closest('.dv-uro-faq__cta-btn');
          if (cta && this.contains(cta)) {
            const target = document.getElementById('mte-buy-box');
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView({ behavior: this.motion.matches ? 'instant' : 'smooth', block: 'start' });
          }
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.dv-uro-faq__item');
          if (!item || !this.contains(item)) return;
          this.filter(item.dataset.faqCategory);
          this.expand(item.querySelector('.dv-uro-faq__question'), true, false);
        }, options);
      }

      filter(category) {
        const tabs = Array.from(this.querySelectorAll('.dv-uro-faq__tab'));
        if (!tabs.some(tab => tab.dataset.tabTarget === category)) return;
        if (tabs.find(tab => tab.classList.contains('is-active'))?.dataset.tabTarget === category) return;
        tabs.forEach(tab => {
          const active = tab.dataset.tabTarget === category;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-pressed', String(active));
        });
        this.querySelectorAll('.dv-uro-faq__item').forEach(item => {
          this.expand(item.querySelector('.dv-uro-faq__question'), false, false);
          item.hidden = item.dataset.faqCategory !== category;
        });
      }

      expand(question, open, animate = true) {
        const panel = document.getElementById(question.getAttribute('aria-controls'));
        const startHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height;
        const startOpacity = panel.hidden ? 0 : Number(getComputedStyle(panel).opacity);
        this.animations.get(panel)?.cancel();
        this.animations.delete(panel);
        question.setAttribute('aria-expanded', String(open));
        panel.setAttribute('aria-hidden', String(!open));
        panel.inert = !open;
        if (!animate || this.motion.matches || typeof panel.animate !== 'function') {
          panel.hidden = !open;
          return;
        }
        panel.hidden = false;
        const animation = panel.animate([
          { height: startHeight + 'px', opacity: startOpacity },
          { height: (open ? panel.scrollHeight : 0) + 'px', opacity: open ? 1 : 0 }
        ], { duration: 220, easing: 'ease' });
        this.animations.set(panel, animation);
        animation.onfinish = () => {
          if (this.animations.get(panel) !== animation) return;
          panel.hidden = !open;
          this.animations.delete(panel);
        };
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.animations?.forEach(animation => animation.cancel());
        this.animations?.clear();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
